export function caseInsensitiveIncludes (string, target) {
  const lowerCaseString = String(string).toLowerCase()
  const lowerCaseTarget = String(target).toLowerCase()

  return lowerCaseString.includes(lowerCaseTarget)
}
